export function buildPartnerUrl(url: string): string {
  return url.replace('/api/', '/');
}
